import React from 'react';
import styled from 'styled-components';
import { layout } from 'src/components/base';

import { Lazy } from 'src/components/lazy';
import { ProductImage } from 'src/components/product-image';
import { CompareCheckbox as CompareCheckboxComponent } from '../compare-checkbox';

import type { BaseProps } from '../../types';

type Props = Pick<
  BaseProps,
  'name' | 'selectable' | 'selected' | 'fallbackImageSrc' | 'imageSrc'
>;

export const CompactListCardMedia: React.FC<Props> = props => {
  const {
    name,
    selectable,
    selected = false,
    fallbackImageSrc,
    imageSrc,
  } = props;

  return (
    <Media>
      {selectable ? (
        <CompareCheckbox selected={selected} aria-label={name} />
      ) : null}
      <Lazy offset={0}>
        <ImageContainer>
          <ListImage
            name={name}
            src={imageSrc || ''}
            fallback={fallbackImageSrc}
          />
        </ImageContainer>
      </Lazy>
    </Media>
  );
};

const Media = styled.div`
  display: flex;
  align-items: center;
`;

export const CompareCheckbox = styled(CompareCheckboxComponent)`
  margin-right: ${layout.measurements.spacing050};
  position: relative;
  top: 0;
  left: 0;
  height: 100%;
`;

export const ImageContainer = styled.div`
  width: 45px;
  box-sizing: content-box;
`;

export const ListImage = styled(ProductImage)`
  max-width: 40px;
`;
